import React, { createContext, useState, useEffect } from 'react';
import { Storage } from '@ionic/storage';

interface LanguageContextType {
  language: 'en' | 'it';
  setLanguage: (lang: 'en' | 'it') => void;
}

export const LanguageContext = createContext<LanguageContextType>({
  language: 'en',
  setLanguage: () => {}
});

const localStore = new Storage();
localStore.create();

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguageState] = useState<'en' | 'it'>('en');

  // Load saved language preference when the app starts
  useEffect(() => {
    const loadSavedLanguage = async () => {
      const savedLanguage = await localStore.get('language');
      if (savedLanguage) {
        setLanguageState(savedLanguage);
      } else {
        // If no language is saved, try to use device language, defaulting to 'en'
        const deviceLanguage = navigator.language.split('-')[0];
        const defaultLanguage = deviceLanguage === 'it' ? 'it' : 'en';
        setLanguageState(defaultLanguage);
        await localStore.set('language', defaultLanguage);
      }
    };
    loadSavedLanguage();
  }, []);

  // Save language preference whenever it changes
  const setLanguage = async (lang: 'en' | 'it') => {
    setLanguageState(lang);
    await localStore.set('language', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}; 